import history from '../../history'

/**
 * @param nextRoute is the next route that will be navigated to.
 */
export const nextRouteIs = (nextRoute: string) => {
  return history && nextRoute === history.location.pathname
}



// WEBPACK FOOTER //
// ./src/lib/route/location.ts